import { http } from './client'
import type {
  MeResponse,
  ResetPasswordResponse,
  UpdateMeRequest,
  UpdateUserRequest,
  UserResponse,
} from './types'

export const getMe = (): Promise<MeResponse> => http.get<MeResponse>('/v0/users/me')

export const updateMe = (data: UpdateMeRequest): Promise<MeResponse> =>
  http.put<MeResponse>('/v0/users/me', data)

export const listUsers = (): Promise<UserResponse[]> => http.get<UserResponse[]>('/v0/users/')

export const updateUser = (userId: string, data: UpdateUserRequest): Promise<UserResponse> =>
  http.put<UserResponse>(`/v0/users/${userId}`, data)

export const deleteUser = (userId: string): Promise<void> => http.del<void>(`/v0/users/${userId}`)

// Выдаёт пользователю новый сгенерированный пароль и завершает все его сессии.
// Пароль приходит один раз — второй запрос породит уже другой.
export const resetUserPassword = (userId: string): Promise<ResetPasswordResponse> =>
  http.post<ResetPasswordResponse>(`/v0/users/${userId}/reset-password`)
